<template>
    <v-card :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}" flat  :dark="$store.getters.getColorPalette().isDark">
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
        <v-data-table
            :headers="headers"
            :items="targets"
            item-key="target_id"
            :search="search"
            :single-expand="true"
            show-expand
            :expanded.sync="expanded"
            :loading="loading"
            loading-text="Loading... Please wait"
            :dark="$store.getters.getColorPalette().isDark"
        >
            <template v-slot:top>
            <v-toolbar
                flat
                :dark="$store.getters.getColorPalette().isDark"
            >
            <v-toolbar-title>{{ $store.getters.getTextMap().targets }}</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <CreateTargetModal v-on:update="getTargets" v-if="$store.state.user && $store.state.settingMode && $store.getters.getAccessByLevels(['engineeraccess'])" />
                <v-icon class="ml-2" small :color="$store.getters.getColorPalette().accentCode" @click="getTargets">mdi-refresh</v-icon>
            </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
                <Target :target="item" v-on:deleteTarget="getTargets" v-on:update="getTargets"/>
            </td>
        </template>
    </v-data-table>
  </v-card>
</template>
<script>
import Target from '@/components/items/derived/Target'
import CreateTargetModal from '@/components/modals/derived/CreateTargetModal'
import axios from 'axios'
import InfoAlert from '@/components/InfoAlert'
export default {
    name:'TargetsTable',
    components:{
        Target,
        CreateTargetModal,
        InfoAlert
    },
    mounted(){
      this.getTargets()
    },
    data(){
        return {
            search:'',
            loading:false,
            info:'',
            showDismissibleAlert:false,
            targets:[],
            expanded: [],
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    filterable: false,
                    value: 'target_id',
                    class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName
                },
                { text: 'Name', value: 'name', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
                { text: 'Default Target', value: 'default_target', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
            ],
        }
    },
    methods:{
        getTargets(){
            this.loading=true
            axios.get(this.$store.state.api+'targets',{headers: {Authorization: 'Bearer '+ this.$store.state.jwt}})
            .then(response=>{
                if(response.data.status=='success'){
                    this.targets=response.data.data
                }else{
                    this.info=response.data.msg
                    this.showDismissibleAlert=true
                }
                this.loading=false
            }).catch(err=>{
                this.loading=false
                this.info=err
                this.showDismissibleAlert=true 
            })
        }
    },
}
</script>
